export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10939.a36ff9eb.jpg";